exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".portal-setup-form .row {\n  padding-top: 10px;\n  padding-bottom: 10px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/portal-setup/portal-setup.scss
// module id = 1065
// module chunks = 0